import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { NewRecipeComponent } from './new-recipe/new-recipe.component';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { EditRecipeComponent } from './edit-recipe/edit-recipe.component';

@Component({
  selector: 'vex-recipes',
  templateUrl: './recipes.component.html',
  styleUrls: ['./recipes.component.scss']
})
export class RecipesComponent implements OnInit {
  searchCtrl = new UntypedFormControl();
  searchCtrlTags = new UntypedFormControl();
  searchCtrlCategory = new UntypedFormControl();
  pageSize = 10;
  pageNumber = 1;
  pageSizeOptions: number[] = [5, 10, 15, 50];
  lunghezza: any;
  dataSource: MatTableDataSource<any> | null
  displayedColumns: string[] = ['title', 'category', 'preparation', 'tags', 'actions'];
  recipes;
  @ViewChild(MatTable) table: MatTable<any>;
  availableTags: string[] = ['Senza glutine', 'Senza lattosio', 'Vegetariana', 'Vegana', 'Salato', 'Dolce'];
  category = [
    { key: 'colazione', description: 'Colazione' },
    { key: 'merenda', description: 'Merenda' },
    { key: 'pranzo', description: 'Pranzo' },
    { key: 'cena', description: 'Cena' }
  ];

  constructor(public translate: TranslateService, public guiService: GuiService, private restService: RestService, private dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.guiService.userLogged) {
      this.search();
    } else {
      this.getCurrent();
    }
  }

  getCurrent() {
    this.restService.getService('current_user', '').subscribe((ris) => {
      this.guiService.userLogged = ris;
      this.search();
    })
  }

  search() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: this.pageNumber,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };

    this.searchCtrl.value && this.searchCtrl.value !== '' ? (param['langKey'] = this.translate.currentLang.toUpperCase(), param['i18nTitleFilter'] = this.searchCtrl.value) : null;
    this.searchCtrlTags.value && this.searchCtrlTags.value !== '' ? param['tagFilter'] = this.searchCtrlTags.value : null;
    this.searchCtrlCategory.value && this.searchCtrlCategory.value !== '' ? param['categoryFilter'] = this.searchCtrlCategory.value : null;

    this.restService.postService('node', '/recipes-list', param).subscribe((ris) => {
      this.recipes = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.recipes;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  reload() {
    this.searchCtrl.reset();
    this.searchCtrlCategory.reset();
    this.searchCtrlTags.reset();

    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: 1,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };
    this.restService.postService('node', '/recipes-list', param).subscribe((ris) => {
      this.recipes = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.recipes;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  resetPage() {
    this.pageNumber = 1;
  }

  onPageChanged(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.search();
  }

  createRecipe() {
    this.dialog.open(NewRecipeComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.search();
      }
    })
  }

  deleteRecipe(id) {
    this.dialog.open(DialogConfirmComponent, {
      width: '250px',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '1ms',
      panelClass: 'dialog-modalbox',
      data: {
        type: 'node-delete-recipe',
        id: id
      }
    }).afterClosed().subscribe((ris) => {
      if (ris != 'true') {
        this.search()
      }
    })
  }

  editRecipe(item?: any['item']) {
    this.dialog.open(EditRecipeComponent, {
      data: item || null,
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((program) => {
      if (program == 'done') {
        this.search()
      }
    })
  }

}
